
import { AllMetrics } from "@/models/metrics";
import { MetricService } from "@/services/metric-service";
import { ApexOptions } from "apexcharts";
import Vue from "vue";
import { setTitle, resetTitle } from "@/utils/title";
import AppActiveUsers from "@/components/ActiveUsersList.vue";
import AppDemoStatistics from "@/components/DemoStatistics.vue";
import AppProfilingActions from "@/components/ProfilingActions.vue";
import AppServerDanglingDbsList from "@/components/ServerDanglingDbsList.vue";
import AppRunningJobList from "@/components/RunningJobsList.vue";
import AppPeppolActions from "@/components/PeppolActions.vue";
import AppQueuedCompanyMoveDbs from "@/components/company/QueuedCompanyMoveDbs.vue";

export default Vue.extend({
	data() {
		return {
			MetricService,
			initialSeries: [] as any[],
			filters: {
				requests: true,
				pdfs: true,
				clients: true,
				runningJobs: true,
				queuedJobs: true
			},
			selectedTab: 0,
		};
	},
	computed: {
		tabs():string[]{
			return ["Gebruikers", "Demo's", "Server", "Peppol"];
		},
		// eslint-disable-next-line max-lines-per-function
		chartOptions():ApexOptions {
			return {
				chart: {
					animations: {
						enabled: false
					}
				},
				xaxis: {
					labels: {
						show: false
					},
					title: {
						text: "Time"
					}
				},
				yaxis: {
					title: {
						text: "Count"
					},
					min: 0,
					forceNiceScale: true
				},
				dataLabels: {
					enabled: false
				}
			};
		},
		metrics():AllMetrics {
			return MetricService.allMetrics;
		},
	},
	watch: {
		"MetricService.allMetrics": {
			async handler(value:AllMetrics) {
				this.updateData();
			}
		},
		filters: {
			deep: true,
			handler() {
				this.updateData();
			}
		}
	},
	methods: {
		updateData() {
			if (!this.$refs.chart) {
				return;
			}
			(this.$refs.chart as any).updateSeries(this.getSeries());
		},
		// eslint-disable-next-line max-lines-per-function
		getSeries() {
			let result = [];
			if (this.filters.requests) {
				result.push({
					name: "Requests",
					data: MetricService.allMetrics.requests
				});
			}
			if (this.filters.pdfs) {
				result.push({
					name: "Pdfs",
					data: MetricService.allMetrics.pdfs
				});
			}
			if (this.filters.clients) {
				result.push({
					name: "Clients",
					data: MetricService.allMetrics.socketConnections
				});
			}
			if (this.filters.runningJobs) {
				result.push({
					name: "Running Jobs",
					data: MetricService.allMetrics.runnningJobs
				});
			}
			if (this.filters.queuedJobs) {
				result.push({
					name: "Queued Jobs",
					data: MetricService.allMetrics.queuedJobs
				});
			}
			return result;
		}
	},
	created() {
		this.initialSeries = this.getSeries();
		setTitle("Metrics");
	},
	async mounted() {
		await MetricService.getMetrics();
		this.updateData();
	},
	destroyed(){
		resetTitle();
	},
	components: {
		AppActiveUsers,
		AppDemoStatistics,
		AppProfilingActions,
		AppRunningJobList,
		AppPeppolActions,
		AppServerDanglingDbsList,
		AppQueuedCompanyMoveDbs
	}
});
